(function () {
  const fileInput = document.querySelector('.line-item-property__field #custom_photo');
  const filenameInput = document.querySelector('.line-item-property__field #custom_photo_filename');
  const fileLink = document.querySelector('.line-item-property__field #custom_photo_link');
  const showStatus = (message) => {
    const uploadStatus = document.querySelector('#upload_status')
    uploadStatus.innerHTML = message;
  }

  if (!fileInput || !fileLink) return;
  fileInput.addEventListener('change', () => {
    // upload the file to the backend and add the link to the form
    const uploadUrl = "/apps/integration/upload/artwork";
    if (fileInput.files?.[0]) {
      const formData = new FormData()
      formData.append('artwork', fileInput.files[0])
      showStatus("Uploading the artwork...");
      fetch(uploadUrl, {
        method: "post",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else if (response.status == 422) {
            return response.json().then((data) => {
              throw new Error(data.message);
            });
          } else {
            throw new Error(
              `Artwork upload failed with status: ${response.status} ${response.statusText}`
            );
          }
        })
        .then(async data => {
          if (data.link) {
            fileLink.value = data.link;
            filenameInput.value = fileInput.files?.[0]?.name;
            showStatus("Successfully uploaded the artwork!");
          }
        })
        .catch((error) => showStatus(error.message));
    }
  })
})()